import { useEffect } from "react"

import * as analytics from "../../utils/analytics"
import { useSegmentIsLoaded } from "./use-segment-is-loaded"

export function usePageTracking(title: string, pathname: string) {
  const segmentIsLoaded = useSegmentIsLoaded()

  useEffect(() => {
    if (segmentIsLoaded) {
      analytics.pageViewed(title)
      analytics.pageLoaded()
    }
  }, [pathname, segmentIsLoaded, title])
}
